import { Component, Input, OnInit, SimpleChanges, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Subscription, pairwise, startWith } from 'rxjs';

@Component({
    selector: 'app-staff-address-form',
    templateUrl: './staff-address-form.component.html',
    styleUrls: ['./staff-address-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StaffAddressFormComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => StaffAddressFormComponent),
            multi: true
        }
    ],
    standalone: false
})
export class StaffAddressFormComponent implements OnInit {
  public staffAddressFormSubscription: Subscription | undefined;
  public isFormTouched = false;
  @Input() form: any = {};
  @Input() isEdit : boolean = false;
  @Input() model: any = {};
  addressDetail: any = '';



  public staffAddressForm: UntypedFormGroup = new UntypedFormGroup({
    staff_address: new UntypedFormControl(null,[Validators.required]),

  });
  initAddressComponentData(value: any = '') {
    console.log('initAddressComponentData', value);
    return {
      address_line_1:  value?.address_line_1,
      address_line_2:  value?.address_line_2 ,
      relations: {
        state:  value?.state,
      },
      city:  value?.city,
      zipcode:  value?.zipcode
    };
  }

  constructor() { }

  ngOnInit(): void {
    this.addressDetail = this.initAddressComponentData(this.model?.staff_detail);
    this.initSubscriptions()
    console.log('modell',this.model)
  }

  ngOnChanges(changes: SimpleChanges) {
    this.model = changes?.model?.currentValue;
  }

  ngAfterViewInit(): void {
    this.setDataOnEdit();
  }

  setDataOnEdit = () => {
    // if(this.isEdit) {
      this.staffAddressForm.get('staff_address')?.setValue({
        address_line_1: this.model?.staff_detail?.address_line_1,
        address_line_2: this?.model?.staff_detail?.address_line_2,
        city: this?.model?.staff_detail?.city,
        state_id: this?.model?.staff_detail?.state,
        zipcode: this?.model?.staff_detail?.zipcode
      });

      // this.addressDetail = {
      //   address_line_1: this.model?.address_line_1,
      //   address_line_2: this.model?.address_line_2,
      //   city: this.model?.city,
      //   state_id: this.model?.state,
      //   zipcode: this.model?.zipcode,
      //   relations: {
      //     state: this.model?.state,
      //   }
      // };
      // console.log('this.addressDetail', this.addressDetail);

    // }
  }

  writeValue(val: any): void {
    val && this.staffAddressForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.staffAddressForm.valueChanges.subscribe(fn);
  }



  public onTouched: () => void = () => {};
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.staffAddressForm.disable() : this.staffAddressForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.staffAddressForm.valid ? null : { invalidForm: {valid: false, message: "Company name fields are invalid"}};
  }

  initSubscriptions(){
    if (this.form){
      this.staffAddressFormSubscription = this.form.valueChanges
        .pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (this.form.touched && !this.isFormTouched){
            this.isFormTouched = true;
            this.touchFormControls();
          }
        });
    }
  }

  touchFormControls(){
    Object.keys(this.staffAddressForm.controls).forEach(key => {
      this.staffAddressForm.get(key)?.markAsTouched();
    });
  }
}
